import React from "react";

import { cn } from "../utils/styling";

type InlineDangerMessageProps = {
  className?: string;
  message: string;
};

export const InlineDangerMessage = ({ className, message }: InlineDangerMessageProps) => {
  if (!message) return null;

  return (
    <div
      className={cn(
        "bg-core-mystic-red-200/40 rounded-md border border-solid border-core-mystic-red-400 px-4 py-3",
        className
      )}
    >
      <p className="text-core-mystic-red-400 font-ds-body-regular-md">{message}</p>
    </div>
  );
};
